import authApi from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
	state: {
		id : null,
		name : '',
		menus: [],
		routers:[],
		token: getToken(),
		account: {}
	},
	getters: {
		hasUserInfo:state=>{
  			return state.id != null
		},
		token:state => {
			return state.token
		}
	},
	mutations: {
		SET_USERID( state,id ) {
			state.id = id
		},
		SET_NAME( state, name ) {
			state.name = name
		},
		SET_SYSTEM_NAME( state, title ) {
			state.title = title
		},
		SET_MENUS( state, menus) {
			state.menus = menus
		},
		SET_ROUTERS( state, routers) {
			state.routers = routers
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_ACCOUNT: (state, account) => {
			state.account = account
		}
	},
	actions: {
		login({ commit },user) {
			return new Promise(( resolve, reject )=>{
				authApi.login(user.username,user.password).then( res => {
					if (res.data.code === 1000) {
						commit('SET_TOKEN', res.data.accessToken)
						setToken(res.data.accessToken)
						resolve(res.data)
					} else {
						Message({
							message: res.data.message || '错误',
							type: 'error',
							duration: 3 * 1000
						})
					}
				}).catch(error=>reject(error))
			})
		},
		getUserInfo({ commit,dispatch }) {
			return new Promise(( resolve, reject )=>{
				authApi.getUserInfo().then( res => {
					if (res.data.code === 1000) {
						// console.log('getUserInfo', res.data.data)
						commit('SET_USERID',res.data.data.id)
						commit('SET_NAME',res.data.data.username)
						commit('SET_SYSTEM_NAME',res.data.data.title)
						commit('SET_MENUS',res.data.data.menus)
						let account = res.data.data.account
						let siteCenter = account.center.split(',')
							account.center = [parseFloat(siteCenter[0]),parseFloat(siteCenter[1])]
						commit('SET_ACCOUNT',account)
						resolve(res.data)
					} else {
						Message({
							message: res.data.message || '错误',
							type: 'error',
							duration: 3 * 1000
						})
					}
				}).catch(error=>{
					dispatch('logout')
					reject(error)
				})
			})
		},
		logout({ commit }) {
			removeToken() // must remove  token  first
			window.location.reload()
		},
		
		setMenus({ commit }, menus) {
			commit('SET_MENUS', menus)
		},
		setRouters({ commit }, routers) {
			commit('SET_ROUTERS', routers)
		},
		hasPath({ state,commit }, path) {
			return state.menus.some((item,index)=>{
				if(item.path==path){
					console.log('hehe')
					return true
				}else{					
					return false
				}
			})
		}
	}
}
export default user
